export default __webpack_public_path__ + "components/page-header/static/icon-menu-64a1db1b35f42b98fca63387540b1ba2.svg";